import { CteValidationEvent } from './cte-monitoring.interface';
import { RegisterValidationStatusType, TradeRepositoryType } from './register.interface';

export enum EDfeStatus {
  SIMULATION = 'SIMULATION',
  AVAILABLE = 'AVAILABLE',
  CONTRACTED = 'CONTRACTED',
  REJECTED = 'REJECTED',
  DISABLED = 'DISABLED',
}

export enum EDfeOrigin {
  XML = 'XML',
  API = 'API',
}

export enum EDfeType {
  CTE = 'CTE',
  NFE = 'NFE',
}

export const formatDfeTypeLabel = (dfeType?: EDfeType) => (dfeType === EDfeType.CTE ? 'CT-e' : 'NF-e');

export interface ICTe {
  id: number;
  nct: string;
  accessKey: string;
  takerName: string;
  issueDate: string;
  value: number;
  events: CteValidationEvent[];
  registers: Array<{
    ctedIs: number;
    registerBatchId: number;
    registerDate: string;
    tradeRepository: TradeRepositoryType;
    status: RegisterValidationStatusType;
    batchUuid?: string;
    registerUuid?: string;
  }>;
  takerBranchId: number;
  takerRootId: number;
  dfeType: EDfeType;
  origin?: EDfeOrigin;
  ndfe: string;
  installmentNumber: number;
  dueDate: string;
  status: EDfeStatus;
}

export interface ICteConciliation {
  contractId: number;
  cteId: number;
  installmentNumber: number;
  settlementValue: number;
  ndfe: string;
  paymentDueIn: string;
  rebate: number;
  value: number;
  partner: string | null;
  financier: string | null;
  takerName: string | null;
  type: string | null;
  contractType: string | null;
  settlementDate?: string;
}

export interface ICTeSecondaryOperation {
  id: number;
  status: string;
  nct: string;
  accessKey: string;
  cfop: number;
  cteType: string;
  serviceType: string;
  issueDate: string;
  value: number;
  signatureDigest: string;
  originFileKey: string;
  takerName: string;
  takerDocumentNumber: string;
  carrierDocumentNumber: string;
  nContract: number;
  dueDate: string;
  carrierTradeName: string;
  tax?: number;
  opValue?: number;
}

export interface ICTeTaxes {
  cteId: number;
  tax: number;
  operationValue: number;
}

export enum CteStatus {
  SIMULATION = 'SIMULATION',
  AVAILABLE = 'AVAILABLE',
  CONTRACTED = 'CONTRACTED',
  REJECTED = 'REJECTED',
  DISABLED = 'DISABLED',
}
